import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/root-store';

import { TestDefinition } from '../model/test-definition';
import { namespace } from '../namespace';

const getPartner = (state: RootState) => state[namespace].data;

const getPartnerId = (state: RootState) => state[namespace].data.id;

const getTestDefinitions = createSelector(
  (state: RootState) => state.common.cities,
  (state: RootState) => state[namespace].data.cityId,
  (cities, cityId): TestDefinition[] =>
    cities.find(city => city.id === cityId)?.testDefinitions ?? [],
);

const getAllTestDefinitions = createSelector(
  (state: RootState) => state.common.cities,
  (cities): TestDefinition[] => cities.map(city => city.testDefinitions ?? []).flat(),
);

const isTestDefinitionsReady = createSelector(
  (state: RootState) => state.common.cities,
  (state: RootState) => state[namespace].data.cityId,

  (cities, cityId) => cities.length > 0 && cityId !== '',
);

const getCity = createSelector(
  (state: RootState) => state.common.cities,
  (state: RootState) => state[namespace].data.cityId,
  (cities, cityId) => cities.find(city => city.id === cityId),
);

const getCityTimezone = createSelector(
  (state: RootState) => state.common.cities,
  (state: RootState) => state[namespace].data.cityId,
  (cities, cityId) => cities.find(city => city.id === cityId)?.timezone,
);
const checkIsOnBoardingCompleted = (state: RootState) =>
  state[namespace].data.onboarding.isCompleted;

const getPartnerType = (state: RootState) => state[namespace].data.partnerType;

const getUploadedDocsForPartner = (state: RootState) => state.partner.data.docUploads;

const getPartnerCountryCode = (state: RootState) => state[namespace].data.countryCode;

export {
  getCityTimezone,
  getPartnerId,
  getPartner,
  getPartnerType,
  getTestDefinitions,
  getAllTestDefinitions,
  getUploadedDocsForPartner,
  getPartnerCountryCode,
  checkIsOnBoardingCompleted,
  isTestDefinitionsReady,
  getCity,
};
